import { useEffect } from "react";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render/index";
import Et3PageTitle from "../../../core/et3-page-title/index";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import Et3Button from "../../../core/et3-button";

import { TEt3PickerSingleValue } from "../../../TypesNEW";
import ET3Div from "../../../core/et3-div";
import i18n from "../../../constants/i18n";
import { KHATTABA_REASSIGN_TYPE } from "../../../constants/picker-entries-constants";
import Et3Picker from "../../../core/et3-input/et3-picker";
import Et3TextInput from "../../../core/et3-input/et3-text-input";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getKhattabatReassignStore from "../../../stores/khattabat-stores/reassign-store";

const ReassignKhataba = withLiteObserverAndTheme(({ theme }) => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "DEVELOPER_REASSIGN_KHATTABA",
      "DEVELOPER_REASSIGN_KHATTABA"
    );
    getKhattabatReassignStore().setAlkhattabatList();
  }, []);
  const { unitX, unitY, colors } = theme;
  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("REASSIGN_KHATTABA")}
        subTitle={i18n.get("REASSIGN_KHATTABA")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1920}
        height={100}
        fDirection="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={"Old khataba "}
          options={getKhattabatReassignStore().alkhattabatList.get()}
          value={getKhattabatReassignStore().oldKhatabaAdminId.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabatReassignStore().setOldKhatabaAdminId(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />

        <Et3Margin top={0} bottom={0} left={30} right={0} />
        <Et3Picker
          label={"New khataba "}
          options={getKhattabatReassignStore().alkhattabatList.get()}
          value={getKhattabatReassignStore().newKhatabaAdminId.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabatReassignStore().setNewKhatabaAdminId(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Picker
        label={i18n.get("TYPE")}
        options={KHATTABA_REASSIGN_TYPE}
        value={getKhattabatReassignStore().typeToReassign.get()}
        onChoose={(value: TEt3PickerSingleValue) => {
          getKhattabatReassignStore().setTypeToReassign(value);
        }}
        isMultiple={false}
        style={{}}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3TextInput
        size="MEDIUM"
        withShadow={false}
        icon={null}
        type={"number"}
        label=""
        placeHolder={"User id to reassign"}
        value={getKhattabatReassignStore().userIdToReassign.get()}
        onChoose={(value: number) => {
          getKhattabatReassignStore().setUserIdToReassign(value);
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{
          minWidth: 250 * unitX,
          minHeight: 45 * unitY,
          width: 250 * unitX,
          height: 45 * unitY
        }}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3TextInput
        size="MEDIUM"
        withShadow={false}
        icon={null}
        type={"text"}
        label="In Arabic"
        placeHolder={"Leaving message"}
        value={getKhattabatReassignStore().leavingArabicMessage.get()}
        onChoose={(value: string) => {
          getKhattabatReassignStore().setLeavingArabicMessage(value);
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{
          minWidth: 550 * unitX,
          minHeight: 45 * unitY,
          width: 550 * unitX,
          height: 45 * unitY
        }}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3TextInput
        size="MEDIUM"
        withShadow={false}
        icon={null}
        type={"text"}
        label="In English"
        placeHolder={"Leaving message"}
        value={getKhattabatReassignStore().leavingEnglishMessage.get()}
        onChoose={(value: string) => {
          getKhattabatReassignStore().setLeavingEnglishMessage(value);
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{
          minWidth: 550 * unitX,
          minHeight: 45 * unitY,
          width: 550 * unitX,
          height: 45 * unitY
        }}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3TextInput
        size="MEDIUM"
        withShadow={false}
        icon={null}
        type={"text"}
        label="In Frensh"
        placeHolder={"Leaving message"}
        value={getKhattabatReassignStore().leavingFrenshMessage.get()}
        onChoose={(value: string) => {
          getKhattabatReassignStore().setLeavingFrenshMessage(value);
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{
          minWidth: 550 * unitX,
          minHeight: 45 * unitY,
          width: 550 * unitX,
          height: 45 * unitY
        }}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3TextInput
        size="MEDIUM"
        withShadow={false}
        icon={null}
        type={"text"}
        label="In Turkish"
        placeHolder={"Leaving message"}
        value={getKhattabatReassignStore().leavingTurkishMessage.get()}
        onChoose={(value: string) => {
          getKhattabatReassignStore().setLeavingTurkishMessage(value);
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{
          minWidth: 550 * unitX,
          minHeight: 45 * unitY,
          width: 550 * unitX,
          height: 45 * unitY
        }}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3TextInput
        size="MEDIUM"
        withShadow={false}
        icon={null}
        type={"text"}
        label="In Indonesian"
        placeHolder={"Leaving message"}
        value={getKhattabatReassignStore().leavingIndonesianMessage.get()}
        onChoose={(value: string) => {
          getKhattabatReassignStore().setLeavingIndonesianMessage(value);
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{
          minWidth: 550 * unitX,
          minHeight: 45 * unitY,
          width: 550 * unitX,
          height: 45 * unitY
        }}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        onClick={() => {
          getKhattabatReassignStore().submitReassign();
        }}
        isEnabled={getKhattabatReassignStore().isReassignEnabled.get()}
        size="LARGE"
        text="REASSIGN_KHATTABA"
        type="APPROVE"
      />
    </ET3PageDiv>
  );
});

export default ReassignKhataba;
